export default __webpack_public_path__ + "static/2_3-cc7cafea373299e31bb735f45474ce43.jpeg";